<template>
  <el-table v-loading="loading" :data="dataList" :height="height">
    <el-table-column v-if="Boolean(customerId)" label="合同编号" min-width="150" align="center">
      <template slot-scope="scope">
        <el-link type="primary" class="crm-link-wrap" :underline="false" @click="toContractDetail(scope.row)">{{scope.row.contractNum}}</el-link>
      </template>
    </el-table-column>
    <el-table-column v-if="!Boolean(contractPlanFundId)" label="关联回款计划" min-width="100" align="center">
      <template slot-scope="scope">
        <el-link type="primary" class="crm-link-wrap" :underline="false" @click="toPlanFundDetail(scope.row)">{{scope.row.planFundBatch}}</el-link>
      </template>
    </el-table-column>
    <el-table-column label="本次回款金额(元)" min-width="130" align="center">
      <template slot-scope="scope">
        <el-link type="primary" class="crm-link-wrap" :underline="false" @click="toDetail(scope.row)">{{ amountFormat(scope.row.actualFundAmount) }}</el-link>
      </template>
    </el-table-column>
    <el-table-column label="本次回款日期" min-width="110" align="center" prop="actualFundDate" />
    <el-table-column label="支付方式" min-width="100" align="center" prop="payTypeDesc" />
    <el-table-column label="回款银行" min-width="100" align="center" prop="bankDesc" />
    <el-table-column label="回款部门" min-width="110" align="center" prop="fundDeptName" />
    <el-table-column label="回款人" min-width="100" align="center" prop="managerName" />
  </el-table>
</template>

<script>

import {listContractFundRecord} from "@/api/crm/fundRecord";
import { amountFormat } from '@/utils/index'

export default {
  name: "FundRecordList",
  props: {
    customerId: {},
    contractId: {},
    contractPlanFundId: {},
    height: {
      type: String,
      default () {
        return "250"
      }
    }
  },
  data() {
    return {
      loading: false,
      dataList: [],
      amountFormat
    };
  },
  created() {
    if (this.customerId || this.contractId) {
      this.queryList();
    }
  },
  components: {
  },
  watch: {
    customerId (val) {
      if (val) {
        this.queryList();
      } else {
        this.dataList = []
      }
    },
    contractId (val) {
      if (val) {
        this.queryList();
      } else {
        this.dataList = []
      }
    },
    contractPlanFundId (val) {
      if (val) {
        this.queryList();
      } else {
        this.dataList = []
      }
    }
  },
  methods: {
    queryList () {
      this.loading = true;
      listContractFundRecord(
        {
        customerId: this.customerId,
        contractId: this.contractId,
        contractPlanFundId: this.contractPlanFundId
      }
      ).then(response => {
          this.dataList = response.rows || [];
          this.$emit('after-query', this.dataList);
          this.loading = false;
        }
      ).catch(error => {
        this.loading = false;
      });
    },
    /** 详细按钮操作 */
    toContractDetail(row) {
      window.open("/crm/contract/detail/" + row.contractId, "_blank")
    },
    /** 详细按钮操作 */
    toPlanFundDetail(row) {
      window.open("/crm/plan-fund/detail/" + row.contractPlanFundId, "_blank")
    },
    /** 详细按钮操作 */
    toDetail(row) {
      window.open("/crm/fund-record/detail/" + row.id, "_blank")
    },
  }
};
</script>
